import {course_getCourseClasses_Api} from 'apis'
import {getId} from 'apis/model/base'
import {createValue} from 'components/form/utils'
import React from 'react'
import ContainerPicker, {renderDefaultActions,} from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper, renderBaseOption} from '../../../../components/selectors/BaseSelector'
import useTranslate from "../../../../modules/local/useTranslate";
import {ItemInformation} from "../../Organization/OrganizationEntity";

export const CourseClassSelector = ({
  name,
  value,
  course_id,
  onChange = NullAsDefault,
  ...props
}) => {
    const t = useTranslate()
    const defaultValue = getId(value) ?? value

    return (
        <ContainerPicker
            name={name}
            allowClear={true}
            defaultValue={defaultValue}
            type={AppEntities.UNDEFINED}
            placeholder="click to select"
            renderInnerWrapper={InnerWrapper}
            renderActions={renderDefaultActions(value)}
            renderOption={renderBaseOption(defaultValue, (option) => ({
                title: option?.title,
                description: (
                    <ItemInformation
                        showIcon={true}
                        label="number of student"
                        value={`${option?.number_of_students} ${t('student')}`}
                        className="text-xs italic"
                    />
                ),
            }))}
            onOptionChange={(option) => {
                onChange(createValue(name, option ?? null))
            }}
            customConfigs={{
                apiInfo: course_getCourseClasses_Api,
                query: bindQueryParam({ id: course_id }),
            }}
            {...props}
        />
    )
}
